import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "TreasuryKRIEssbaseSummary" })((_theme) => ({
  page: {
    margin: "20px",
  },
  treasuryKRIEssbaseSummaryExportBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "-30px",
  },
}));
